import React from 'react'
import { Downgraded } from '@hookstate/core'
import { useLang } from '~/hooks/useLang'
import { Grid, Typography } from '@mui/material'
import ColumnChartHorizontal from '~/components/ColumnChartMui/HorizontalChart'
import { calculateBarChartTotal } from '~/utils/format'
import useManagementQualifiersOrgansState from '~/features/Management/stores/ManagementQualifiersOrgansState'

interface ChartsObjectProps {
  readonly expandFilterSearch: boolean
}

export default function ChartsOrgans({
  expandFilterSearch,
}: ChartsObjectProps) {
  const { translate } = useLang()
  const { occurrencesAssociatedOrgans } = useManagementQualifiersOrgansState()


  return (
    <Grid
      container
      xs={12}
      sx={{
        display: 'flex',
        paddingX: 3,
        paddingTop: 3,
        justifyContent: 'space-between',
      }}
    >
      <Grid item xs={12} hidden={!expandFilterSearch} paddingBottom={1}>
        <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
          {translate('Registered Organs')}
        </Typography>
      </Grid>

      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedOrgans()
            .occurrencesAssociatedOrgansByType.attach(Downgraded)
            .get()}
          title={'Organ Type'}
          subtitle={`Total de órgãos: ${calculateBarChartTotal(
            occurrencesAssociatedOrgans()
              .occurrencesAssociatedOrgansByType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="primary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedOrgans()
            .occurrencesAssociatedOrgansByCircunstance.attach(Downgraded)
            .get()}
          title={`${translate('number of organ records x types of occurrence')}`}
          subtitle={`Total de órgãos: ${calculateBarChartTotal(
            occurrencesAssociatedOrgans()
              .occurrencesAssociatedOrgansByCircunstance.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'typeMinus'}
          colorBar="secondary"
        />
      </Grid>
      <Grid
        item
        xs={6}
        hidden={!expandFilterSearch}
        paddingRight={1}
        paddingBottom={1}
      >
        <ColumnChartHorizontal
          data={occurrencesAssociatedOrgans()
            .occurrencesAssociatedOrgansByOccurrenceType.attach(Downgraded)
            .get()}
          title={`${translate('organs registered by procedure')}`}
          subtitle={`Total de órgãos: ${calculateBarChartTotal(
            occurrencesAssociatedOrgans()
              .occurrencesAssociatedOrgansByOccurrenceType.attach(Downgraded)
              .get()
          )}`}
          typeTotal={'situations'}
          colorBar="tertiary"
        />
      </Grid>
    </Grid>
  )
}
